export const DELIVERY_AND_PICKUP_V2 = 'DELIVERY_AND_PICKUP_V2';

export const TODAY = 'TODAY';
export const TOMORROW = 'TOMORROW';
export const CLOSED = 'CLOSED';
export const REQUIRED_STORE_FIELDS = ['sddCutOffTime', 'cutOffTime', 'schedule'] as const;
